import { UploadCloudSvgIcon } from "components/SVGIcons";
import styles from "./style.module.scss";

type DropzoneFileProps = {
  onChange: (event: any) => Promise<void>;
  onDrop: (files: File[]) => Promise<void>;
};

export default function DropzoneFile({ onChange, onDrop }: Readonly<DropzoneFileProps>) {
  const handleDrop = (event: React.DragEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    onDrop(Array.from(event.dataTransfer.files));
  };

  const handleDragOver = (event: React.DragEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragEnter = (event: React.DragEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragLeave = (event: React.DragEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <button
      type="button"
      className={styles.dropZone}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}>
      <UploadCloudSvgIcon className="h-10 w-14 text-primary" />
      <label className={styles.uploadBtn}>
        <span>BROWSE FILE</span>
        <input type="file" hidden onChange={onChange} accept=".pdf, .jpg, .jpeg, .png" />
      </label>
    </button>
  );
}
